export enum TripGroupDirection {
  Outbound = 'outbound',
  Inbound = 'inbound',
}

export enum TripGroupSlotType {
  Pickup = 'pickup',
  Dropoff = 'dropoff',
}
